export const GrantContract = {
    _form: function () {
        // Date pickers
        jQuery('#modal-dialog .date').flatpickr({ dateFormat: "Y-m-d", static: true, allowInput: true });
        jQuery('#modal-dialog .open-datepicker').on('click', function () {
            jQuery(this).closest('.input-group').find('.date').focus();
        });

        // File upload
        var zone = jQuery('#grant-contract-upload');
        var dz = new Dropzone('#' + zone.attr('id'), {
            url: zone.data('upload-url'),
            headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content') },
            dictDefaultMessage: I18n.t('attachment_drop_multiple_instruction'),
            addRemoveLinks: true,
            dictRemoveFile: ''
        });
        dz.on("processing", function (file) {
            dz.options.url = zone.data('upload-url') + '?uuid=' + file.upload.uuid
        });
        dz.on('addedfile', function (file) {
            zone.find('.dz-preview').last().append('<input type="hidden" name="contract[files[' + zone.attr('data-upload-id') + '][new]][]", value="' + file.upload.uuid + '" />');
            jQuery('.modal-footer button').last().attr('disabled', true);
        });
        dz.on('success', function(file){
            jQuery('.modal-footer button').last().attr('disabled', false);
        })
        // Move file previews to the bottom of drop area and handle delete
        zone.find('.dz-preview').appendTo(zone).on('click', 'a.delete-file', function(event) {
            jQuery(event.currentTarget).closest('.dz-preview').remove();
            return false;
        });
    }
}